/* eslint-disable no-mixed-operators */

import { useMemo } from 'react';

import { useLocation } from "react-router-dom";

export function useQuery() {
    const { search } = useLocation();
    return useMemo(() => {
        const sp = new URLSearchParams(search)
        return sp;
    }, [search]);
}

export function useSimpleQuery() {
    const { search } = useLocation();
    return useMemo(() => {
        const sp = new URLSearchParams(search)
        return Object.fromEntries(Array.from(sp.keys()).map(k => [k, sp.get(k)]));
    }, [search]);
}
